module.exports = __webpack_public_path__ + "img/img-related14.f9785613.jpg";